/**
 * What: The one rule for when a field's Worker message is drawn.
 * Transport / data-flow: A message was written for the text the Worker last saw. While the merchant has an edit the Worker
 *   has not answered for that field, that text is gone, so the old message is about something else and is not drawn. The
 *   answer to the new text brings the right message. Every field kind that carries a message (`BuilderFieldBlock`) is read
 *   through this function. Notes in a section's status area are not tied to one field and are not covered; they stay until
 *   the next answer. `waitingOn` is not a message about text and is not covered either: it stays while the field is off.
 * LLM INSTRUCTION: DO NOT read `block.message` directly in a renderer. Call `visibleMessage`.
 */
import type { BuilderFieldBlock, BuilderFieldMessage } from '@testfeed/shopify-contracts'

export function visibleMessage(
  block: BuilderFieldBlock,
  pending: ReadonlyMap<string, string>,
): BuilderFieldMessage | undefined {
  if (pending.has(block.key)) return undefined
  return block.message ?? undefined
}
